import { render, staticRenderFns } from "./widgetGradientColorBarchart.vue?vue&type=template&id=2606c51d&scoped=true&"
import script from "./widgetGradientColorBarchart.vue?vue&type=script&lang=js&"
export * from "./widgetGradientColorBarchart.vue?vue&type=script&lang=js&"
import style0 from "./widgetGradientColorBarchart.vue?vue&type=style&index=0&id=2606c51d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606c51d",
  null
  
)

export default component.exports